// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedBibliographyType {
  article: {"enum_constant":"article"};
  book: {"enum_constant":"book"};
}

export type BibliographyTypeId = keyof IParsedBibliographyType;
export type BibliographyTypeData = IParsedBibliographyType[BibliographyTypeId];
const data: BibliographyTypeData[] = [{"enum_constant":"article"},{"enum_constant":"book"}];
export default data;
